import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const changePasswordThunk = createAsyncThunk(
  "changePassword/do",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/settings/change-password", payload);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.message || "Password updated";
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const slice = createSlice({
  name: "changePassword",
  initialState: { saving: false, error: null, success: null },
  reducers: {
    clearChangePasswordMsg(state) {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(changePasswordThunk.pending, (s) => { s.saving = true; s.error = null; s.success = null; });
    b.addCase(changePasswordThunk.fulfilled, (s, a) => { s.saving = false; s.success = a.payload; });
    b.addCase(changePasswordThunk.rejected, (s, a) => { s.saving = false; s.error = a.payload || "Failed"; });
  },
});

export const { clearChangePasswordMsg } = slice.actions;
export default slice.reducer;
